import { IonButton, IonIcon } from '@ionic/react'
import { checkmarkOutline } from 'ionicons/icons'

import type { StepView } from '../../lib/api'

import { useChallenge } from './Challenge'
import type { DockProps } from './StepDock'

/**
 * Everything gathered, and one button.
 *
 * The button is disabled until the challenge is solved rather than submitting
 * and bouncing: the customer has filled in everything by this point, and a
 * rejected confirm reads as the booking having failed.
 */
export function ReviewDock({ view, busy, onSend }: DockProps) {
  const challenge = useChallenge(view)

  return (
    <>
      <Summary view={view} />
      {challenge.node}
      <IonButton
        expand="block"
        disabled={busy || !challenge.ready}
        onClick={() => onSend({ ...challenge.payload }, 'Confirmed')}
      >
        {!challenge.ready ? (
          'Complete the check above'
        ) : busy ? (
          'Confirming…'
        ) : (
          <>
            <IonIcon slot="start" icon={checkmarkOutline} />
            Confirm appointment
          </>
        )}
      </IonButton>
    </>
  )
}

function Summary({ view }: { view: StepView }) {
  const rows: [string, string][] = []
  const answers = view.answers

  if (answers.customerName) rows.push(['Name', String(answers.customerName)])
  if (answers.customerMobile) rows.push(['Contact', String(answers.customerMobile)])

  if (answers.chooseSlot) {
    const slot = new Date(String(answers.chooseSlot))
    rows.push([
      'When',
      new Intl.DateTimeFormat('en-IN', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      }).format(slot),
    ])
  }

  // The person only when there is one. A "Who" row reading "Dr. " on a business
  // that never named anybody is worse than no row.
  if (view.tenant.ownerName) rows.push(['Who', view.tenant.ownerName])
  rows.push(['Where', view.tenant.businessName])

  return (
    <dl className="blooq-card">
      {rows.map(([label, value]) => (
        <div className="blooq-card__row" key={label}>
          <dt className="blooq-card__k">{label}</dt>
          <dd className="blooq-card__v">{value}</dd>
        </div>
      ))}
    </dl>
  )
}
